
<div class="separator">
  <div class="separator__line"></div>
  <div class="separator__label">{{ label }}</div>
  <div class="separator__line"></div>
</div>